import { Object3D } from "three";

/** Stored in the userData of a room label's note icon hit box. */
export default interface IRoomNoteTarget {
    globalId: string;       // The room's space product globalId
    roomName: string;
    note: string | null;    // Null when the icon offers to add a note
}

/** Stored in the userData of a room label's group, so hovering any part of the label can reveal its add-note icon. */
export interface IRoomLabelHoverTarget {
    setHovered(hovered: boolean): void;
}

export const ROOM_NOTE_TARGET_KEY = "roomNoteTarget";
export const ROOM_LABEL_HOVER_TARGET_KEY = "roomLabelHoverTarget";

export const getRoomNoteTarget = (object: Object3D | null | undefined): IRoomNoteTarget | undefined =>
    object?.userData?.[ROOM_NOTE_TARGET_KEY] as IRoomNoteTarget | undefined;

// Raycasts hit the label's meshes, so look up through their ancestors for the label group
export const getRoomLabelHoverTarget = (object: Object3D | null | undefined): IRoomLabelHoverTarget | undefined => {
    for (let o = object; o; o = o.parent) {
        const target = o.userData?.[ROOM_LABEL_HOVER_TARGET_KEY] as IRoomLabelHoverTarget | undefined;
        if (target) return target;
    }
    return undefined;
};
